export const FETCH_DYNAMIC_SEARCH_SUGGESTIONS = 'FETCH_DYNAMIC_SEARCH_SUGGESTIONS';
export const FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS = 'FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS';
export const FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED = 'FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED';
export const CLEAR_DYNAMIC_SEARCH_SUGGESTIONS = 'CLEAR_DYNAMIC_SEARCH_SUGGESTIONS';
export const SET_DYNAMIC_SEARCH_QUERY = 'SET_DYNAMIC_SEARCH_QUERY';
export const ENTER_KEY_DYNAMIC_SEARCH_ACTION = 'ENTER_KEY_DYNAMIC_SEARCH_ACTION';
export const REAL_DYNAMIC_SEARCH_ACTION = 'REAL_DYNAMIC_SEARCH_ACTION';
export const FETCH_DYNAMIC_SEARCH_REDIRECT = 'FETCH_DYNAMIC_SEARCH_REDIRECT';
export const FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS = 'FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS';
export const FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL = 'FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL';
export const CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION = 'CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION';
export const CLEAR_DYNAMIC_SEARCH_METRICS = 'CLEAR_DYNAMIC_SEARCH_METRICS';

export const MINIMUM_DYNAMIC_SEARCH_QUERY_LENGTH = 1;

export interface RedirectSuggestionResponse {
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
    title?: string;
    url_key?: string;
    highlight?: string | null;
    productCount?: number;
    redirect_method?: string;
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
}

export interface DynamicSearchSuggestionBucket {
    title: string;
    urlKey: string;
    highlight: string;
    productCount: number;
    redirectMethod: string;
}

export interface DynamicSearchSuggestionsQueryResponse {
    name?: string;
    highlight?: string | null;
}
export interface DynamicSearchSuggestionsResponse {
    data?: {
        queries?: DynamicSearchSuggestionsQueryResponse[];
    };
}
export interface DynamicSearchSuggestion {
    name: string;
    highlightHtml: string;
}

export interface RedirectSuggestions {
    categories: DynamicSearchSuggestionBucket[];
    brands: DynamicSearchSuggestionBucket[];
    products: DynamicSearchSuggestionBucket[];
    staticPages: DynamicSearchSuggestionBucket[];
}

export interface DynamicSearchRedirectsResponse {
    data?: {
        Categories?: RedirectSuggestionResponse[];
        Brands?: RedirectSuggestionResponse[];
        Products?: RedirectSuggestionResponse[];
        StaticPages?: RedirectSuggestionResponse[];
    };
}

export interface DynamicSearchSuggestionsState {
    isFetching: boolean;
    didInvalidate: boolean;
    query: string;
    isEnterKeySearch: boolean;
    isRealSearch: boolean;
    suggestions: DynamicSearchSuggestion[];
    error?: any;
    searchRedirect: RedirectSuggestions;
    clickedSuggestion: string;
}

export interface FetchDynamicSearchSuggestionsAction {
    type: typeof FETCH_DYNAMIC_SEARCH_SUGGESTIONS;
}

export interface ClearDynamicSearchMetricsAction {
    type: typeof CLEAR_DYNAMIC_SEARCH_METRICS;
}

export interface EnterKeyDynamicSearchAction {
    type: typeof ENTER_KEY_DYNAMIC_SEARCH_ACTION;
    payload: { isEnterKeySearch: boolean };
}
export interface RealDynamicSearchAction {
    type: typeof REAL_DYNAMIC_SEARCH_ACTION;
    payload: { isRealSearch: boolean };
}
export interface ClickedDynamicSearchSuggestionAction {
    type: typeof CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION;
    payload: { clickedSuggestion: string };
}

export interface ClearDynamicSearchSuggestionsAction {
    type: typeof CLEAR_DYNAMIC_SEARCH_SUGGESTIONS;
    payload: { exemptQuery?: boolean };
}

export interface FetchDynamicSearchSuggestionsSuccessAction {
    type: typeof FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS;
    payload: DynamicSearchSuggestionsResponse;
}

export interface FetchDynamicSearchSuggestionsFailedAction {
    type: typeof FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED;
    payload: Error;
}

export interface SetDynamicSearchQueryAction {
    type: typeof SET_DYNAMIC_SEARCH_QUERY;
    payload: { query: string };
}

export interface FetchDynamicSearchRedirectsAction {
    type: typeof FETCH_DYNAMIC_SEARCH_REDIRECT;
}

export interface FetchDynamicSearchRedirectSuccessAction {
    type: typeof FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS;
    payload: DynamicSearchRedirectsResponse;
}

export interface FetchDynamicSearchRedirectFailedAction {
    type: typeof FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL;
    payload: Error;
}

export type DynamicSearchSuggestionsActionTypes =
    | FetchDynamicSearchSuggestionsAction
    | FetchDynamicSearchSuggestionsSuccessAction
    | FetchDynamicSearchSuggestionsFailedAction
    | ClearDynamicSearchSuggestionsAction
    | EnterKeyDynamicSearchAction
    | SetDynamicSearchQueryAction
    | RealDynamicSearchAction
    | FetchDynamicSearchRedirectsAction
    | FetchDynamicSearchRedirectSuccessAction
    | FetchDynamicSearchRedirectFailedAction
    | ClickedDynamicSearchSuggestionAction
    | ClearDynamicSearchMetricsAction;
